import jQuery from 'jquery';
let $ = jQuery;

import "LIBS/jquery.showhtml.js";
import "./Widget.js";
    
/**
    * class HSN.Widget.FlexPayPayNow
    *
    * Encapsulates the common functionality of the FlexPayPayNow Widget.
    **/
HSN.Widget.FlexPayPayNow = function () {
    var application;
    var container;
    var accountService;
    var deviceInformation;
    var orderIdentity;
    var paymentNumbers;
    /**
        * new HSN.Widget.FlexPayPayNow.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.FlexPayPayNow]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
        **/
    function init(config) {
        application = config.application;
        container = $(config.container);
        accountService = application._getAccountService();
        deviceInformation = application.DeviceInformation;
        orderIdentity = config.orderIdentity;
        paymentNumbers = config.paymentNumbers;

        if (deviceInformation.IsMobile) {
            SetMyEventHandlers();
        }

        bindEvents();
    }

    function bindEvents() {
        container.on('click', '#pay-now', function () {
            var isAuthorized = $('.authorization-check', container).is(':checked');
            if (!isAuthorized) {
                alert('Please confirm that you have reviewed the details before submitting.');
                return false;
            }

            container.html('');
            HSN.SetContainerWait(container);
            accountService.FlexPayGetProcessingPage({ orderIdentity: orderIdentity, flexPayNumbers: paymentNumbers }, {
                callback: function (content) {
                    HSN.RemoveContainerWait();
                    container.showHtml(
                        content,
                        0,
                        function () {
                        },
                        function () {
                        }
                    );
                },
                errorCallback: function () {

                }
            });
                
            HSN.DataLayer.helpers.metricEvent(null, "RE:flexpaymanager", "authorization", "paynow");

            return false;
        });
        container.on('click', '#cancel', function() {
            HSN.Instance().Events.Trigger(HSN.Widget.FlexPayPayNow.EVENT.CANCELLED, orderIdentity);

            HSN.DataLayer.helpers.metricEvent(null, "RE:flexpaymanager", "authorization", "cancel");

            return false;
        });
    }
    function ClearChildEventHandlers() {
    }
    function ClearMyEventHandlers() {
    }
    function SetMyEventHandlers() {
    }
    function Destroy() {
        ClearMyEventHandlers();
        ClearChildEventHandlers();
    }
    return {
        init: init,
        Destroy: Destroy
    }
};

HSN.Widget.FlexPayPayNow.EVENT = {
    CANCELLED: 'HSN.Widget.FlexPayPayNow:CANCELLED'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/FlexPayPayNow.js